import ListClients from './views/ListClients.vue'
import CreateClient from './views/CreateClient.vue'
import HomeLayout from '@/layouts/Home.vue'
import ClientDetail from './views/ClientDetail.vue'

export const clientRoutes = [
  {
    path: '/clients',
    name: 'clients',
    component: ListClients,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin'],
    },
  },
  {
    path: '/clients/add',
    name: 'client/add',
    component: CreateClient,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin'],
    },
  },
  {
    path: '/clients/:id',
    name: 'clients/detail',
    component: ClientDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['superadmin'],
    },
  },
]
